<template>
  <div class="container page-content">
    
    <div class="row page-content__heading">
      <div class="col-12">
        <h1>{{ $t('eligible_products.heading') }}</h1>
      </div>
    </div>

    <div v-if="dataIsLoaded" class="row page-content__products">
      <div class="col-md-4 text-center">
        <img class="img-fluid" src="@/assets/images/prod-oven.jpg" alt="">
      </div>
      <div class="col-md-8">

        <div class="row">
          <div class="col products__heading">
            <img src="@/assets/images/ico-oven.png" alt=""> {{ $t('common.ovens') }}
          </div>
        </div>

        <div class="row">
          <div class="col products__list">
            <ul>
              <li v-for="product in this.filterProductsByCatId(this.category.ovens)" :key="product.id">
                {{ product.symbol }}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <div v-if="dataIsLoaded" class="row page-content__products">
      <div class="col-md-4 text-center">
        <img class="img-fluid" src="@/assets/images/prod-kitchen.jpg" alt="">
      </div>
      <div class="col-md-8">

        <div class="row">
          <div class="col products__heading">
            <img src="@/assets/images/ico-kitchen.png" alt=""> {{ $t('common.cookers') }}
          </div>
        </div>

        <div class="row">
          <div class="col products__list">
            <ul>
              <li v-for="product in this.filterProductsByCatId(this.category.kitchens)" :key="product.id">
                {{ product.symbol }}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

    <div v-if="dataIsLoaded" class="row page-content__products">
      <div class="col-md-4 text-center">
        <img class="img-fluid" src="@/assets/images/prod-hob.jpg" alt="">
      </div>
      <div class="col-md-8">

        <div class="row">
          <div class="col products__heading">
            <img src="@/assets/images/ico-hobs.png" alt=""> {{ $t('common.hobs') }}
          </div>
        </div>

        <div class="row">
          <div class="col products__list">
            <ul>
              <li v-for="product in this.filterProductsByCatId(this.category.hobs)" :key="product.id">
                {{ product.symbol }}
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import { globalStore } from '@/main';
  import scrollToElement from 'scroll-to-element'

  export default {
    name: "eligibleProducts",
    data () {
      return {
        products: [],
        dataIsLoaded: false,
        category: {
          ovens: 1,
          kitchens: 2,
          hobs: 3
        }
      }
    },
    mounted () {
      this.fetchProductsData();

      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      })
    },
    methods: {
      fetchProductsData () {
        let cmp = this
        cmp.axios.get(globalStore.API_BASE_URL + 'products').then((response) => {
          let responseData = response.data
          cmp.products = responseData.data
          cmp.dataIsLoaded = true
        })
      },
      filterProductsByCatId (catId) {
        return this.products.filter(product => product.category_id == catId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;

    .page-content__heading {
      margin-bottom: 40px;
      
      h1 {
        font-size: 34px;
        font-weight: 300;
      }

      .heading__info {
        font-size: 12px;
        margin-top: 10px;
        font-weight: 400;
      }
    }

    .page-content__products {
      margin-top: 80px;

      .products__heading {
        background: #f0f0f0;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: 900;
        font-size: 14px;
        text-transform: uppercase; 
        
        img {
          margin-right: 10px;
        }
      }

      .products__list {
        ul {
          list-style: none;
          padding-left: 20px;
          margin-bottom: 0px;
          margin-top: 20px;
          columns: 3;
          -webkit-columns: 3;
          -moz-columns: 3;

          li {
            margin-bottom: 10px;
          }
        }
      }

    }
  }
</style>
